import React, { createContext, useMemo, useCallback, useContext } from 'react';

import PropTypes from 'prop-types';
import { usePersistedState } from '../utils/Common';
import { UserProfileContext } from './UserProfileProvider';

export const CartContext = createContext();


export const CartProvider = ({ children }) => {
  const { tokenLoaded } = useContext(UserProfileContext);
  const [cartCount, setCartCount] = usePersistedState('cartCount', tokenLoaded ? localStorage.getItem("cartCount") : 0);
  const [cartId, setCartId] = usePersistedState('cartId', undefined);
  const [cart, setCart] = usePersistedState('cart', undefined);
  const [qty, setQty] = usePersistedState('qty', {});
  const [weight, setWeight] = usePersistedState('weight', []);
  const [deliveryDate, setDeliveryDate] = usePersistedState('deliveryDate', '');
  const [addedEntities, setAddedEntities] = usePersistedState('addedEntities', new Set());
  const [paymentInfo, setPaymentInfo] = usePersistedState('paymentInfo', undefined);
  const [orders, setOrders] = usePersistedState('orders', []);
  const [ordersCount, setOrdersCount] = usePersistedState('ordersCount', 0);
  const clearCartState = useCallback(() => {
    setCartId(null);
    setCartCount(0);
    setCart(null);
    setQty([]);
    setAddedEntities([]);
    setOrders([]);
    const nextWeek = new Date();
    nextWeek.setDate(nextWeek.getDate() + 9);
    setDeliveryDate(nextWeek);
    localStorage.removeItem("CART-ID");
    localStorage.removeItem("cartCount");
    // other localStorage items to clear
  }, [setCartId, setCartCount, setCart, setQty, setAddedEntities, setOrders, setDeliveryDate]);
  const value = useMemo(() => ({
    cartCount, setCartCount, weight, setWeight,
    cartId, setCartId, paymentInfo, setPaymentInfo, orders, setOrders, ordersCount, setOrdersCount,
    cart, setCart,
    qty, setQty,
    deliveryDate, setDeliveryDate,
    addedEntities, setAddedEntities,
    clearCartState
  }), [addedEntities, cart, cartCount, cartId, clearCartState, deliveryDate, orders, ordersCount, paymentInfo, qty, setAddedEntities, setCart, setCartCount, setCartId, setDeliveryDate, setOrders, setOrdersCount, setPaymentInfo, setQty, setWeight, weight]);
  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
};
CartProvider.propTypes = {
  children: PropTypes.node,
};

